import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl,InputLabel,Button, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select,Menu, MenuItem, Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle, useForkRef } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'
import { getUnit } from "@mui/material/styles/cssUtils";
import { BakeryDining } from "@mui/icons-material";


const AdminEtudiants = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)
  
  const [popupText,setPopupText]=useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser,setPopupUser]=useState(null)
  const [newUser,setNewUser]=useState(null)

  const [nom, setNom] = useState('Tous');
  const [prenom, setPrenom] = useState('Tous');
  const [pseudo, setPseudo] = useState('Tous');
  const [campus, setCampus] = useState('Tous');
  const [programme, setProgramme] = useState('Tous');
  const [groupe, setGroupe] = useState('Tous');

  const [nomOptions,setNomOptions] = useState([])
  const [prenomOptions,setPrenomOptions] = useState([])
  const [pseudoOptions,setPseudoOptions] = useState([])
  const [groupes,setGroupes]=useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [programmeOptions,setProgrammeOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  const getUniqueValues = (data, attribute,campus, programme, groupe) => {

    if(data==null ) return []

    const filtered_data = data
        .filter((val)=>val.campus==campus || campus == "Tous" || attribute=="campus")
        .filter((val)=>val.programme==programme || programme == "Tous" || attribute=="campus" || attribute=="programme")
        .filter((val)=>val.groupe==groupe || groupe == "Tous" || attribute=="campus"  || attribute=="programme" || attribute=="groupe")

    const values = filtered_data?.map(item => {
      if (attribute === "numJeu") {
        return item[attribute] - 10; // Si l'attribut est 'numJeu', soustraire 10
      }
      return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
    });
  
    const uniqueValues = [...new Set(values)].filter((val)=>val!="").sort(); 
    uniqueValues.unshift("Tous"); 
    return uniqueValues;
  };

  useEffect(() => {
    if (users !== null && users.length>0) {
      setNomOptions(getUniqueValues(users,"nom",campus, programme, groupe))
      setPrenomOptions(getUniqueValues(users,"prenom",campus, programme, groupe))
      setPseudoOptions(getUniqueValues(users,"pseudo",campus, programme, groupe))
      // setCampusOptions(getUniqueValues(users,"campus"))
      // setCampusOptions(getUniqueValues(users,"campus"))
      // setGroupesOptions(getUniqueValues(users,"groupe"))
      filterAndGroupList(users)
    }
  }, [users])

  // useEffect(()=>{
  //   if (groupes !== null && groupes.length>0) {
  //     setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
  //     setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
  //     setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
  //   }
  // },[groupes])


  useEffect(()=>{
    if (groupes !== null && groupes.length>0) {
      setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
      setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
      setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
    }
    
  },[groupes,campus,programme])

  useEffect(()=>{
    if( groupes.filter((val)=> val.programme== programme && val.campus==campus).length==0){
      setProgramme("Tous")
    }

     if( groupes.filter((val)=> val.programme== programme && val.campus==campus && val.groupe == groupe).length==0){
      setGroupe("Tous")
    }
    
  },[campus])

  useEffect(()=>{   
    if( groupes.filter((val)=>val.groupe== groupe && val.programme== programme && val.campus == campus).length==0){
      setGroupe("Tous")
    }
  },[programme])

  useEffect(()=>{
    if(groupe!="Tous"){
      setProgramme(groupes.filter((val)=>val.groupe== groupe)[0].programme)
      setCampus(groupes.filter((val)=>val.groupe== groupe)[0].campus)
    }
  },[groupe])



  const filterAndGroupList=(users)=>{
    if (users==null){return []}
    const groupedByUser = users
      .filter((user) => (nom && nom!="Tous" ? user.nom==nom: true))
      .filter((user) => (prenom && prenom!="Tous" ? user.prenom==prenom: true))
      .filter((user) => (pseudo && pseudo!="Tous" ? user.pseudo==pseudo: true))
      .filter((user) => (campus && campus!="Tous" ? user.campus==campus: true))
      .filter((user) => (programme && programme!="Tous" ? user.programme==programme: true))
      .filter((user) => (groupe && groupe!="Tous" ? user.groupe==groupe: true))

      setLocalUsers(groupedByUser)
      return groupedByUser;
    }



  useEffect(()=>{
    
    const localUserList=filterAndGroupList(users)

    if (nom=="Tous"){
      if(groupe=="Tous"){
        if(campus=="Tous"){
          
          if(pseudo=="Tous"){
            setPrenomOptions(getUniqueValues(users,"prenom",campus, programme, groupe))
            setNomOptions(getUniqueValues(users,"nom",campus, programme, groupe))
            setPseudoOptions(getUniqueValues(users,"pseudo",campus, programme, groupe))
            // setCampusOptions(getUniqueValues(users,"campus"))
            // setGroupesOptions(getUniqueValues(users,"groupe"))
          }else{
            setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
            setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
            setPseudoOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
            // setCampusOptions(getUniqueValues(localUserList,"campus"))
            // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
          }

        }else{
          setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
          setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
          setPseudoOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))

        }


      }else{
        setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
        setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
        setPseudoOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
      }




    }else{
      setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
      setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
      setPseudoOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))

    }
    
  

  },[nom,prenom,pseudo,campus,programme,groupe])
    
  const handleFilterChange = (setter) => (event) => {
    setter(event.target.value);
  };

  useEffect(()=>{
    if(users==null || groupes==null){
      clickActualiser()
    }
    setLocalUsers(users)
  },[users])


  const clickActualiser = async () => {
    // if (users == null){
    const users = await BackendAPI.getEtudiants()
    const groupes = await BackendAPI.getGroupes()
    setUsers(users)
    setGroupes(groupes)
    // console.log(groupes)
    // }
    // setActualiser(false)
   
  }
  
  const updateServer =async(value,field,id) => {
    // event.preventDefault()
    // console.log("etudiant update",field,value, id)
    // var value="false"
    // if(field!=="actif"){
    //   value=event.target.value
    // }
    if(field=="email"){
      value=value.toLowerCase()
    }

    

    // if(field=="campus"){
    //   await BackendAPI.updateEtudiant("","programme",id)
    //   await BackendAPI.updateEtudiant("","groupe",id)
    // }
    // if(field=="programme"){
    //   await BackendAPI.updateEtudiant("","groupe",id)
    // }
    
     await BackendAPI.updateEtudiant(value,field,id)
    //  setUsers(null)
  }
  
  const handleClicNewUser=async()=>{
    // console.log(newUser)
    await BackendAPI.createUser(newUser)
    setNewUser(null)
    clickActualiser()
  }

  const handleChangeUser = (newValue, field, id) => {
    // setActualiser(true)
    // const newValue = event.target.value;

    // Crée une nouvelle liste d'utilisateurs avec les modifications apportées
    const updatedUsers = localUsers?.map(user =>
      user.id === id
        ? { ...user, [field]: newValue }
        : user
    );

    // Met à jour l'état avec la nouvelle liste d'utilisateurs
    setLocalUsers(updatedUsers);
  };

  const handleChangeNewUser = (event, field) => {
    // console.log(event)
    if(event!= undefined){

      var newValue = event
      // if(event!=undefined && event!=null && event.target!=null && event.target!=undefined ){
      //   newValue=event.target.value;
      // }
        // console.log(newValue,event!=undefined ,event!=null,event.target!=null , event.target!=undefined )

      // console.log("newUser",newUser, !Object.keys(newUser).includes(field), (newUser != null && field in newUser && newUser[field] != newValue))

      if (
        newUser == null || 
        (newUser != null && !Object.keys(newUser).includes(field)) || 
        (newUser != null && field in newUser && newUser[field] != newValue)
      ) {


        // console.log("NEW VALUE",newValue)


        const user = {
          ...newUser,
          [field]: field !== "email" ? newValue : newValue.toLowerCase()
        };
        // console.log(user)
        setNewUser(user);
      }      
    }   
  };

  // useEffect(()=>{
  //   console.log(newUser)
  // },[newUser])



  const handleKeyDown =  (event,field,id)=> {
    if (event.key === 'Enter') {
      event.preventDefault(); 
      updateServer(event.target.value,field,id);
    }
  };

  const handleBlur =  (value,field,id)=> {
    updateServer(value,field,id);
  };

  const handleClicDelete=(u)=>{
    const popupText= <Typography>
    Souhaitez-vous confirmer la suppression de l'utilisateur suivant ?
    <br />
    {u.nom} {u.prenom} - {u.email} - {u.campus} - {u.programme} - {u.groupe}
</Typography>
    setPopupUser(u)
    setPopupText(popupText)
  }

  const renderChoices=(champ,u)=>{
    var val=""

    const mode_new=!(u!==null &&u.id!=undefined)



    if (champ=="Campus"){
      
      var options = [...campusOptions].filter((val)=>val!="Tous")
      if(u!=null){
        val=u.campus
        options=getUniqueValues(groupes,"campus",campus, "Tous", "Tous").filter((val)=>val!="Tous")
      }
      if(options.length==1){
        val = options[0]
      }
      
      if(mode_new){
        if(val!=undefined && val!=""){ handleChangeNewUser(val,"campus")}
       
        return(
          <FormControl variant="outlined" style={{width:"100%"}}  >
          <InputLabel >{u!==null && u.id!=undefined?null:"Campus"}</InputLabel>

          <Select
            
            value={val}
            displayEmpty
            label={u!==null && u.id!=undefined?null:"Campus"}
            onChange={(e)=>{handleChangeNewUser(e.target.value,"campus")} }
            onBlur={(e)=>{handleChangeNewUser(e.target.value,"campus")} }
            >
           
            {options.filter((val)=>val!="Tous")?.map(c => (
            <MenuItem key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          </FormControl>  
        )
      
      }else{
        
        // if(u.campus!=val){
        
        if(val!=undefined && val!=""){ handleBlur(val,"campus",u.id)}
        // }
        return(
          // <FormControl >
  
          
          <Select style={{width:"100%"}} 
            value={val}
            variant="outlined"
            displayEmpty
            // multiple={true}
            onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e.target.value,"campus",u.id)}} }
            onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e.target.value,"campus",u.id)}} }
            >
           
            {options.filter((val)=>val!="Tous")?.map(c => (
            <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          // </FormControl>
        ) 
      }
     
    }

    if (champ=="Programme"){
      
      var options = [...programmeOptions].filter((val)=>val!="Tous")
      if(u!=null){
        val=u.programme
        options=getUniqueValues(groupes,"programme",u.campus, "Tous", "Tous").filter((val)=>val!="Tous")
         if(options.length==0) {
          options=getUniqueValues(groupes,"programme","Tous","Tous", "Tous").filter((val)=>val!="Tous")
        }
      }
      
      // console.log()
     
      // options=options.filter((val)=>val!="Tous")

      if(options.length==1){
        val = options[0]
      }

      // console.log("TEST ",val,options)

      
      if(mode_new){
        if(val!=undefined && val!=""){handleChangeNewUser(val,"programme")}
        
        return(
          <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel>Programme</InputLabel>
              <Select
                value={val || ""} // <-- Assure-toi que val n'est jamais undefined
                displayEmpty
                label="Programme"
                onChange={(e) => handleChangeNewUser(e.target.value, "programme")}
                onBlur={(e) => handleChangeNewUser(e.target.value, "programme")}
              >
                {options.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
        )
      }else{
        // if(u.programme!=val){
        
        if(val!=undefined && val!=""){handleBlur(val,"programme",u.id)}
        
        return(
          // <FormControl >
  
          
          <Select style={{width:"100%"}} 
            value={val}
            displayEmpty
            variant="outlined"
            onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e.target.value,"programme",u.id)}} }
            onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e.target.value,"programme",u.id)}} }
            >
           
            {options.filter((val)=>val!="Tous")?.map(c => (
            <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          // </FormControl>
        ) 
      }
    }


    if (champ=="Groupe"){
      var options=[...groupesOptions].filter((val)=>val!="Tous")

      if(u!=null){
        val=u.groupe

        options=getUniqueValues(groupes,"groupe",u.campus,u.programme, "Tous").filter((val)=>val!="Tous")
        if(options.length==0) {
          options=getUniqueValues(groupes,"groupe",u.campus,"Tous", "Tous").filter((val)=>val!="Tous")
        }
         if(options.length==0) {
          options=getUniqueValues(groupes,"groupe","Tous","Tous", "Tous").filter((val)=>val!="Tous")
        }
        // console.log("TEST",options,u.campus,u.programme)
      }
      // options=options
      // console.log(options)
      if(options.length==1){
        val = options[0]
      }
     

      if(mode_new){
        if(val!=undefined && val!=""){handleChangeNewUser(val,"groupe")}
        
        return(
          <FormControl variant="outlined" style={{width:"100%"}} >
          <InputLabel >{u!==null && u.id!=undefined ? null:"Groupe"}</InputLabel>

          <Select
          
            value={val}
            displayEmpty
            label={u!==null && u.id!=undefined?null:"Groupe"}
            onChange={(e)=>{handleChangeNewUser(e.target.value,"groupe")} }
            onBlur={(e)=>{handleChangeNewUser(e.target.value,"groupe")} }
            >
           
            {options?.map(c => (
            <MenuItem key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          </FormControl>  
        )
      
      }else{
        if(val!=undefined && val!=""){ handleBlur(val,"groupe",u.id)}
       
        return(
          // <FormControl >
  
          
          <Select
            value={val}
            variant="outlined"
            displayEmpty
            onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e.target.value,"groupe",u.id)}} }
            onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e.target.value,"groupe",u.id)}} }
            >
           
            {options.filter((val)=>val!="Tous")?.map(c => (
            <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          // </FormControl>
        ) 
      }
    }
  }

  const renderUsers = () => {
    if (localUsers !== null) {
      return (
        <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
          <Table  stickyHeader aria-label="customized table">
            <TableHead>
              <TableRow >
                {/* <TableCell align="center">Id</TableCell> */}

                <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Prénom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Email</TableCell>

                <TableCell align="center"  style={{ width: 150 }}>Pseudo</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Campus</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Programme</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Groupe</TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                {/* <Button
          variant="contained"
          style={{padding:4}}
          className=""
          color={"primary"}
          disabled={!actualiser}
        >
          {"Actualiser"}
        </Button> */}

                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localUsers?.map((u) => (
                <TableRow key={u.id} style={{height:10}}>
                  {/* <TableCell align="center">{u.id}</TableCell> */}
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  value={u.nom}
                  onChange={ (e)=>handleChangeUser(e.target.value,"nom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
                  onBlur={ (e)=>handleBlur(e.target.value,"nom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.prenom}
                  onChange={ (e)=>handleChangeUser(e.target.value,"prenom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
                  onBlur={ (e)=>handleBlur(e.target.value,"prenom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 300 }}> <TextField
                  value={u.email}
                  onChange={ (e)=>handleChangeUser(e.target.value,"email",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  onBlur={ (e)=>handleBlur(e.target.value,"email",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.pseudo}
                  onChange={ (e)=>handleChangeUser(e.target.value,"pseudo",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
                  onBlur={ (e)=>handleBlur(e.target.value,"pseudo",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("Campus",u)}
                </TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("Programme",u)}
                </TableCell>
                <TableCell align="center">
                  {renderChoices("Groupe",u)}
                </TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                  <IconButton aria-label="delete" >
                    <DeleteIcon color="primary" onClick={(e)=>{
                      handleClicDelete(u)
                      // handleBlur(e,"actif",u.id)
                    }}/>
                  </IconButton>
                </TableCell>
                </TableRow>
              ))} 

              {renderNewUser()}     
            </TableBody>
          </Table>
        </TableContainer>)
    }

    return null

  }

  const renderNewUser = () => {

    var disabled = !newUser  || !newUser.nom || newUser.nom.length === 0 || !newUser.prenom || newUser.prenom.length === 0 || !newUser.email || newUser.email.length === 0 || !newUser.campus || newUser.campus.length === 0 || !newUser.programme || newUser.programme.length === 0 || !newUser.groupe || newUser.groupe.length === 0 
    // console.log(Object.keys(newUser).length>1)

      return (
         <TableRow key={"NEW USER"}>
          <TableCell align="center" style={{ width: 150 }}> <TextField
          label="Nom"
          value={newUser!=null && newUser.prenom!=""? newUser.nom : ''}
          onChange={ (e)=>handleChangeNewUser(e.target.value,"nom")}
          // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"nom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
          <TableCell align="center" style={{ width: 150 }}> <TextField
          label="Prénom"
          value={newUser!=null &&  newUser.prenom!=""? newUser.prenom : ''}
          onChange={ (e)=>handleChangeNewUser(e.target.value,"prenom")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" style={{ width: 300 }}> <TextField
          placeholder="Email"
          value={newUser!=null &&  newUser.email!="" ? newUser.email : ''}
          onChange={ (e)=>handleChangeNewUser(e.target.value,"email")}
          // onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
          // onBlur={ (e)=>handleBlur(e,"email",u.id)}
          variant="outlined"
          label="Email"
          size="small"
        /></TableCell>
          <TableCell align="center" style={{ width: 150 }}> <TextField
          label="Pseudo"
          value={newUser!=null &&  newUser.pseudo!="" ? newUser.pseudo : ''}
          onChange={ (e)=>handleChangeNewUser(e.target.value,"pseudo")}
          // onChange={ (e)=>handleChangeUser(e,"pseudo",u.id)}
          // onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
          // onBlur={ (e)=>handleBlur(e,"pseudo",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" style={{ width: 150 }}> 
          {renderChoices("Campus",newUser)}
        </TableCell>

        <TableCell align="center" style={{ width: 150 }}>
          {renderChoices("Programme",newUser)}
        </TableCell>

        <TableCell align="center" style={{ width: 150 }}>
          {renderChoices("Groupe",newUser)}
        </TableCell>
        <TableCell align="center" style={{ width: 50 }}>
          <IconButton aria-label="ajouter"  disabled={disabled}>
            <AddIcon  
                color={disabled ?"default":"secondary"}
              //  || !newUser.nom || newUser.nom.length === 0
              
              onClick={(e)=>{
                handleClicNewUser()
              // handleClicDelete(u)
              // handleBlur(e,"actif",u.id)
            }}/>
          </IconButton>
        </TableCell>
        </TableRow> )
    }


  const handleClosePopup=async(choix)=>{
    
    switch (choix) {
      case 'Supprimer Utilisateur':
        // console.log(popupUser.id)
        // setActualiser(true)
        await BackendAPI.updateEtudiant("false","actif",popupUser.id)
        setPopupUser(null)
        setUsers(null)  
    }

    setPopupText(null)
  }

const exportToCSV = () => {
  if (!localUsers || localUsers.length === 0) {
    alert("Aucun utilisateur à exporter !");
    return;
  }

  // Définition des colonnes CSV
  const headers = ["Id","Nom", "Prénom", "Pseudo","Email",  "Campus", "Programme","Groupe","Actif"];

  // Génération des lignes
  const rows = localUsers.map(u => [
    u.id,
    u.nom,
    u.prenom,
    u.pseudo,
    u.email,
    u.campus,
    u.programme,
    u.groupe,
    u.actif ? "OUI" : "NON"
  ]);

  // Transformation en texte CSV
  const csvContent = [
    headers.join(";"), // séparateur ;
    ...rows.map(row => row.join(";"))
  ].join("\n");

  // Création du fichier Blob
  // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  // Création d'un lien de téléchargement temporaire
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "Utilisateurs.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div 
      className="body-admin"
    >
      <Typography variant="h1" color="primary">Étudiants</Typography>
      <Divider />
      {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      }
             <div style={{margin:10}}  >
<div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>

            
            <FormControl size="small" variant="outlined">
              <InputLabel>Nom</InputLabel>
              <Select
                value={nom}
                onChange={handleFilterChange(setNom)}
                label="Nom"
              >
                      {nomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Prénom</InputLabel>
              <Select
                value={prenom}
                onChange={handleFilterChange(setPrenom)}
                label="Prénom"
              >
                      {prenomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Pseudo */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Pseudo</InputLabel>
              <Select
                value={pseudo}
                onChange={handleFilterChange(setPseudo)}
                label="Pseudo"
              >

                {pseudoOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>
              <Select
                value={campus}
                onChange={handleFilterChange(setCampus)}
                label="Campus"
              >
                {campusOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

             <FormControl size="small" variant="outlined">
              <InputLabel>Programme</InputLabel>
              <Select
                value={programme}
                onChange={handleFilterChange(setProgramme)}
                label="Programme"
              >

                {programmeOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupe</InputLabel>
              <Select
                value={groupe}
                onChange={handleFilterChange(setGroupe)}
                label="Groupe"
              >

                {groupesOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton aria-label="download" style={{padding:10}} onClick={exportToCSV}>
            <DownloadIcon  
            />
          </IconButton>
            {/* <IconButton 
              color="primary" 
              onClick={exportToCSV}
            >
              <DownloadIcon />
            </IconButton> */}

          </div>
          <br></br>        

          {renderUsers()}

        {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>
            


      {/* </div> */}

    </div></div>
  );
}

export default AdminEtudiants;

